import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Select } from 'new/elements/Select';
import { TextField } from '@nexla/new/elements/TextField';

import styles from '../ReadStats.module.scss';
import { FILE_LIST_MODE_TYPES } from 'js/constants/paginationConstants';

interface ReadStatusHeaderProps {
  onChangeSort: (e: any) => void;
  onChangeStatus: (e: any) => void;
  onSearchChange: (e: any) => void;
  sort: string;
  status: string;
  sortByItems: any[];
  filterByStatus: any[];
  rightContent?: React.ReactNode;
  isAdaptiveFlow?: boolean;
  mode?: keyof typeof FILE_LIST_MODE_TYPES;
}

const ReadStatusHeader = (props: ReadStatusHeaderProps) => {
  const {
    sort,
    status,
    mode = FILE_LIST_MODE_TYPES.MODE_READ,
    sortByItems,
    filterByStatus,
    onChangeSort,
    onChangeStatus,
    onSearchChange,
    rightContent = null,
    isAdaptiveFlow = false,
  } = props;

  const modeLabel = mode === FILE_LIST_MODE_TYPES.MODE_READ ? 'Ingestion History' : 'Write History';
  return (
    <div className={styles.listFilters}>
      <Stack direction="row" alignItems="center" gap="8px">
        <Typography variant="subtitle1" fontSize={14}>
          {isAdaptiveFlow ? 'Processing Status' : modeLabel}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap="16px">
        <TextField onChange={onSearchChange} placeholder="Type to filter by name" />
        <Select
          sx={{ minWidth: 150 }}
          items={sortByItems}
          value={sort}
          onChange={onChangeSort}
          size="small"
        />
        <Select
          sx={{ minWidth: 150 }}
          items={filterByStatus}
          value={status}
          onChange={onChangeStatus}
          size="small"
        />
      </Stack>
      {mode === FILE_LIST_MODE_TYPES.MODE_READ && (
        <Stack
          direction="row"
          alignItems="center"
          gap="16px"
          flexBasis={250}
          justifyContent="flex-end"
        >
          {rightContent}
        </Stack>
      )}
    </div>
  );
};

export default React.memo(ReadStatusHeader);
